import React from 'react';
import { Form, Checkbox } from 'antd';

//https://ant.design/components/checkbox
const FormCheckBox = ({ label, name, rules, noStyle = false, ...rest }) => {
  return (
    <Form.Item
      name={name}
      rules={rules}
      valuePropName="checked"
      noStyle={noStyle}
    >
      <Checkbox {...rest}>{label}</Checkbox>
    </Form.Item>
  );
};

export default FormCheckBox;
